<template>
  <v-container fluid class="hero-section pa-0">
    <v-container>
      <v-row align="center" justify="space-between">
        
        <!-- LADO ESQUERDO -->
        <v-col cols="12" md="6">
          
          <div class="badge">
            SISTEMA PROFISSIONAL PARA TRANSPORTADORAS
          </div>

          <h1 class="hero-title">
            Gerencie sua 
            <span class="highlight">transportadora</span> 
            com controle total
          </h1>

          <p class="hero-subtitle">
            Controle motoristas, veículos e despesas de viagem em um único lugar.
            Sem planilhas. Sem complicação. Com chatbot WhatsApp integrado
            para seus motoristas.
          </p>

          <div class="hero-buttons">
            <v-btn
              large
              rounded
              color="#10b981"
              class="mr-4 white--text font-weight-bold"
              elevation="2"
              to="/cadastro"
            >
              Testar grátis por 15 dias
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>

            <v-btn
              large
              rounded
              outlined
              color="#1ED760"
              class="font-weight-bold"
            >
              <v-icon left>mdi-whatsapp</v-icon>
              Tirar Dúvidas
            </v-btn>
          </div>

          <div class="hero-features mt-6">
            <div>🔒 Dados Seguros</div>
            <div>⚡ Setup Rápido</div>
            <div>📊 Suporte 24/7</div>
          </div>

        </v-col>

        <!-- LADO DIREITO -->
        <v-col cols="12" md="6" class="d-flex align-center justify-center">
          <div class="video-card">
            <video
              src="https://cdn.pixabay.com/video/2021/10/03/90727-626984931_large.mp4"
              controls
              autoplay
              muted
              loop
              playsinline
              class="hero-video"
            ></video>
          </div>
        </v-col>

      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "HeroTransportadora"
}
</script>

<style scoped>

.hero-section {
  /* background: radial-gradient(circle at top left, #0f172a, #020617); */
  min-height: 100vh;
  display: flex;
  align-items: center;
  color: white;
}

.badge {
  display: inline-block;
  background: rgba(30, 215, 96, 0.1);
  color: #10b981;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 20px;
}

.hero-title {
  font-size: 48px;
  font-weight: 800;
  line-height: 1.2;
}

.highlight {
  color: #10b981;
}

.hero-subtitle {
  margin-top: 20px;
  color: #94a3b8;
  font-size: 18px;
  max-width: 500px;
}

.hero-buttons {
  margin-top: 30px;
}

.hero-features {
  display: flex;
  gap: 30px;
  font-size: 14px;
  color: #94a3b8;
}

.dashboard-card {
  background: #0b1220;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 0 60px rgba(0, 255, 150, 0.05);
}

.metrics {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.metric-card {
  flex: 1;
  padding: 15px;
  border-radius: 12px;
  margin-right: 10px;
}

.metric-card:last-child {
  margin-right: 0;
}

.metric-title {
  font-size: 12px;
  opacity: 0.7;
}

.metric-value {
  font-size: 24px;
  font-weight: bold;
  margin-top: 5px;
}

.green {
  background: linear-gradient(135deg, #125a4c, #10b981);
}

.blue {
  background: linear-gradient(135deg, #1e3a8a, #1d4ed8);
}

.purple {
  background: linear-gradient(135deg, #4c1d95, #6d28d9);
}

.chart-area {
  background: #0f172a;
  border-radius: 12px;
  height: 150px;
  position: relative;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-label {
  position: absolute;
  top: 10px;
  left: 15px;
  font-size: 12px;
  color: #94a3b8;
}

.chart-placeholder {
  max-width: 100%;
  max-height: 100%;
}

.trip-list {
  margin-top: 10px;
}

.trip-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #0f172a;
  padding: 12px;
  border-radius: 10px;
  margin-bottom: 10px;
  font-size: 14px;
}

/* Video Card Style */
.video-card {
  background: #0b1220;
  border-radius: 20px;
  box-shadow: 0 0 60px rgba(0, 255, 150, 0.05);
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
}

.hero-video {
  width: 100%;
  height: 340px;
  max-height: 60vh;
  object-fit: cover;
  border-radius: 20px;
  display: block;
}
</style>